import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { EntityData, HorizontalListData, HorizontalListFactory, HorizontalListItemSize } from "common";

@Injectable()
export class BankLinkingInfoWidgetAdapter {
  constructor(
    private readonly datePipe: DatePipe,
  ) { }

  adaptListData = (data: EntityData, canReadBankAccountVerificationStatus: boolean): HorizontalListData[] => {
    const hasBankLinkStatusInfo = data?.bankLinkStatusInfo?.length > 0;
    
    return [
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: 'Link status',
        customTemplateName: 'linkStatusValue',
        hideDividerBelow: hasBankLinkStatusInfo,
      }),
      HorizontalListFactory.createInfoStringItem({
        displayedValue: data?.bankLinkStatusInfo?.join("<br>"),
        isItemHidden: !hasBankLinkStatusInfo,
        itemSize: HorizontalListItemSize.Small
      }),
      HorizontalListFactory.createKeyValueCustomValueTemplateItem({
        title: "Verification status",
        customTemplateName: 'verificationStatusValue',
        isItemHidden: !canReadBankAccountVerificationStatus,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Link attempt count',
        displayedValue: data?.linkingAttemptCount?.toString(),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Successful link attempt',
        displayedValue: data?.successfullLinkingAttemptCount?.toString(),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Last link attempt date',
        displayedValue: this.formatDate(data?.lastLinkingAttemptDate),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Last sync date',
        displayedValue: this.formatDate(data?.bankIntegrationLastSync),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Link reminder count',
        displayedValue: data?.linkReminderCount?.toString(),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Link reminder last displayed date',
        displayedValue: this.formatDate(data?.linkReminderLastDisplayedDate),
      }),
    ]
  }

  private formatDate(value: Date): string {
    return this.datePipe.transform(value, "short");
  }
}